import type { CropVarietyConfigurationsByKey } from "../types.js";

export const walnutVarietyConfigurations = {
    "walnut.ashley": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.chandler": { crop: "walnut", aliases: [], isExample: true, customName: false },
    "walnut.durham": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.fernor": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.forde": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.franquette": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.gillet": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.hartley": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.howard": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.ivanhoe": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.lara": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.livermore": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.payne": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.pedro": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.robert-livermore": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.serr": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.sexton": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.solano": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.tulare": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.vina": { crop: "walnut", aliases: [], isExample: false, customName: false },
    "walnut.custom": { crop: "walnut", aliases: [], isExample: false, customName: true },
} as const satisfies CropVarietyConfigurationsByKey;
